import { render, staticRenderFns } from "./modal_criar_horario.vue?vue&type=template&id=6d0950b1&scoped=true&"
import script from "./modal_criar_horario.vue?vue&type=script&lang=js&"
export * from "./modal_criar_horario.vue?vue&type=script&lang=js&"
import style0 from "./modal_criar_horario.vue?vue&type=style&index=0&id=6d0950b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0950b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSelect,VTextField})
